<!-- search bar -->
<div class="container-section-detail">
    <div class="content-wrap list-products-page">
        <div class="container">
            <div class="breadcrumb">
                <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
            </div>
            <div class="title-catalogue d-flex justify-content-between align-items-center">
                <h2 style="line-height: 32px">
                    {{ currentProduct?.shortDescription | translateDynamicLanguage }}
                </h2>
            </div>
            <div class="wrap-general-info pb-5">
                <div class="d-flex">
                    <div class="group-img w-6 pr-2">
                        <div class="d-flex justify-content-between">
                            <ng-container
                                *ngIf="
                                    (currentProduct?.resources?.length ?? 0) > 1;
                                    else elseTemplateNotImageThanThree
                                "
                            >
                                <!-- Custom Gallery: Vertical Layout -->
                                <ng-container *ngIf="orientation === 'vertical'">
                                    <button
                                        class="btn-prev-vertical btn-prev p-button p-button-rounded p-button-text"
                                        (click)="prev()"
                                        [disabled]="activeIndex === 0"
                                    >
                                        <mat-icon>keyboard_arrow_up</mat-icon>
                                    </button>

                                    <div class="thumbnail-list-vertical">
                                        <div
                                            class="thumbnail-item"
                                            [class.active]="i === activeIndex"
                                            *ngFor="
                                                let resource of currentProduct?.resources;
                                                let i = index
                                            "
                                            (click)="selectImage(i)"
                                        >
                                            <img
                                                [src]="resource?.files?.[0]?.thumbnailUrl ?? imgDefault"
                                                [alt]="resource?.title || 'Image ' + (i + 1)"
                                                class="thumbnail-img"
                                            />
                                        </div>
                                    </div>

                                    <button
                                        class="btn-next-vertical btn-next p-button p-button-rounded p-button-text"
                                        (click)="next()"
                                        [disabled]="
                                            activeIndex ===
                                            (currentProduct?.resources?.length ?? 1) - 1
                                        "
                                    >
                                        <mat-icon>keyboard_arrow_down</mat-icon>
                                    </button>
                                </ng-container>

                                <!-- Custom Gallery: Horizontal Layout -->
                                <ng-container *ngIf="orientation === 'horizontal'">
                                    <button
                                        class="btn-prev-horizontal btn-prev p-button p-button-rounded p-button-text"
                                        (click)="prev()"
                                        [disabled]="activeIndex === 0"
                                    >
                                        <mat-icon>keyboard_arrow_left</mat-icon>
                                    </button>

                                    <div class="thumbnail-list-horizontal">
                                        <div
                                            class="thumbnail-item"
                                            [class.active]="i === activeIndex"
                                            *ngFor="
                                                let resource of currentProduct?.resources;
                                                let i = index
                                            "
                                            (click)="selectImage(i)"
                                        >
                                            <img
                                                [src]="resource?.files?.[0]?.thumbnailUrl ?? imgDefault"
                                                [alt]="resource?.title || 'Image ' + (i + 1)"
                                                class="thumbnail-img"
                                            />
                                        </div>
                                    </div>

                                    <button
                                        class="btn-next-horizontal btn-next p-button p-button-rounded p-button-text"
                                        (click)="next()"
                                        [disabled]="
                                            activeIndex ===
                                            (currentProduct?.resources?.length ?? 1) - 1
                                        "
                                    >
                                        <mat-icon>keyboard_arrow_right</mat-icon>
                                    </button>
                                </ng-container>
                            </ng-container>

                            <ng-template #elseTemplateNotImageThanThree>
                                <div class="list-img d-flex justify-content-between">
                                    <div
                                        (click)="showImage(img?.files?.[0]?.thumbnailUrl)"
                                        class="wrap-item-img d-flex justify-content-center align-items-center"
                                        *ngFor="let img of currentProduct?.resources"
                                    >
                                        <img
                                            [src]="img?.files?.[0]?.thumbnailUrl ?? imgDefault"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </ng-template>

                            <div class="img-show d-flex justify-content-center align-items-center">
                                <div class="wrap-img-zoom">
                                    <lib-ngx-image-zoom
                                        class="mx-auto img custom-zoom"
                                        [thumbImage]="imgShow || ''"
                                        [fullImage]="imgShow || ''"
                                        [magnification]="0.6"
                                        [enableScrollZoom]="false"
                                        [enableLens]="true"
                                        [lensWidth]="160"
                                        [lensHeight]="160"
                                        [circularLens]="false"
                                    ></lib-ngx-image-zoom>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="group-info w-6 pl-2">
                        <div class="date-product">
                            <span
                                >{{ 'IRONSIDE.new-productDetail.LAST_UPDATE_DATE' | translate }}:
                                {{ currentProduct?.updatedAt | date : 'dd/MM/yyyy' }}</span
                            >
                        </div>
                        <div class="code-product">
                            <p>
                                <strong
                                    >{{ 'IRONSIDE.new-productDetail.BRAND' | translate }}: </strong
                                >{{ currentProduct?.brand | translateDynamicLanguage }}
                            </p>
                            <p>
                                <strong
                                    >{{
                                        'IRONSIDE.product-list.department'
                                            | translate
                                            | lowercase
                                            | titlecase
                                    }}:
                                </strong>
                                <ng-container
                                    *ngFor="let item of currentProduct?.department; let last = last"
                                >
                                    {{ item.labels | translateDynamicLanguage
                                    }}<span *ngIf="!last"> , </span>
                                </ng-container>
                            </p>
                            <p *ngIf="currentProduct?.standard">
                                <strong
                                    >{{
                                        'IRONSIDE.new-productDetail.STANDARD' | translate
                                    }}: </strong
                                >{{ currentProduct?.standard }}
                            </p>

                            <!-- Other -->
                            <p *ngIf="hasLanguagePropertyValue(currentProduct?.other)">
                                <strong
                                    >{{ 'IRONSIDE.new-productDetail.OTHER' | translate }}: </strong
                                >{{ currentProduct?.other | translateDynamicLanguage }}
                            </p>

                            <!-- Standards: CE / Other Standards -->
                            <p *ngIf="hasStandardsValue()">
                                <strong
                                    >{{
                                        'IRONSIDE.new-productDetail.STANDARD' | translate
                                    }}: </strong
                                >{{ getStandardsValue() }}
                            </p>
                        </div>
                        <a class="goTofeatures" (click)="goToFeatures()">{{
                            'IRONSIDE.new-productDetail.ACCESS_FEATURES' | translate
                        }}</a>
                        <div class="description-product">
                            <p>
                                <strong
                                    >{{
                                        'IRONSIDE.new-productDetail.DESCRIPTION' | translate
                                    }}: </strong
                                ><span
                                    [innerHTML]="
                                        currentProduct?.longDescription | translateDynamicLanguage
                                    "
                                ></span>
                            </p>
                        </div>
                        <div class="wrap-btn d-flex align-items-center">
                            <button
                                *ngIf="isPermissionFonctions('comparateur-produit')"
                                style="margin-right: 4px"
                                class="btn-common comparer-btn d-flex align-items-center me-3"
                                (click)="addProductToCompare(currentProduct?.id)"
                                (mouseenter)="onToggleIcon($event, 'yellow')"
                                (mouseleave)="onToggleIcon($event, 'white')"
                            >
                                <img
                                    id="comparator-icon"
                                    class="me-2"
                                    src="/src-ironside/assets/icons/comparator_white.svg"
                                    alt=""
                                />{{ 'IRONSIDE.new-productDetail.COMPARE' | translate }}
                            </button>
                            <button
                                [ngClass]="
                                    currentProduct?.isFavorite
                                        ? 'btn-favorite-selected'
                                        : 'btn-favorite-unselected'
                                "
                                *ngIf="isPermissionFonctions('favoris')"
                                mat-icon-button
                            >
                                <ng-container *ngIf="currentProduct?.isFavorite; else elseTemplate">
                                    <img
                                        (click)="removeFromFavorites()"
                                        src="src-ironside/assets/icons/bookmark_yellow.svg"
                                        alt="icon-favorite-selected"
                                        width="27"
                                        height="27"
                                    />
                                </ng-container>
                                <ng-template #elseTemplate>
                                    <div
                                        class="d-flex align-items-center gap-1"
                                        (click)="checkHasFavorites()"
                                        [matMenuTriggerFor]="menu"
                                    >
                                        <mat-icon style="font-size: 16px; width: 14px; color: #000"
                                            >add</mat-icon
                                        >
                                        <span>{{
                                            'IRONSIDE.product-list.my-lists' | translate
                                        }}</span>
                                        <img
                                            src="src-ironside/assets/icons/bookmark_black.svg"
                                            alt="icon-favorite-unselected"
                                            width="27"
                                            height="27"
                                        />
                                    </div>
                                </ng-template>
                            </button>
                            <mat-menu #menu>
                                <ng-container *ngFor="let item of favorites">
                                    <button (click)="addToFavorites(item.id)" mat-menu-item>
                                        {{ item.name }}
                                    </button>
                                </ng-container>
                                <div class="container-btn-create-favourit">
                                    <button
                                        (click)="onOpenDialog(currentProduct!)"
                                        mat-menu-item
                                        class="btn-create-favourit"
                                    >
                                        <mat-icon>add</mat-icon>
                                        {{ 'IRONSIDE.product-list.create-new-list' | translate }}
                                    </button>
                                </div>
                            </mat-menu>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section id="features" class="tabView-product">
        <div class="container">
            <app-tabview-product [product]="currentProduct"></app-tabview-product>
        </div>
    </section>
    <ng-container *ngIf="currentProduct">
        <app-list-product [productDetail]="currentProduct!"></app-list-product>
    </ng-container>
</div>
